import { render, staticRenderFns } from "./VideoClassify.vue?vue&type=template&id=35cb30ea&"
import script from "./VideoClassify.vue?vue&type=script&lang=ts&"
export * from "./VideoClassify.vue?vue&type=script&lang=ts&"
import style0 from "./VideoClassify.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports